import { type AnswersState } from '.';

const initialState: AnswersState = {
  data: [],
  ticketDescription: '',
};

export default initialState;
